var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"content":_vm.headerContent}}),_c('div',{staticClass:"wrap-catalyst"},[(_vm.user && _vm.license)?_c('ModuleCatalyst',{attrs:{"user":_vm.user,"license":_vm.license}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }